import { LazyImport, LazyModule } from 'owa-bundling';

export {
    ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
    DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
} from './utils/retentionPolicyConstants';
export { default as getRetentionPolicyMenuItem } from './utils/getRetentionPolicyMenuItem';
export { default as getAssignPolicyPropertiesForMailContextMenu } from './utils/getAssignPolicyPropertiesForMailContextMenu';
export { default as isSelectedPolicyDifferentForFolder } from './helpers/isSelectedPolicyDifferentForFolder';

import './orchestrators/itemsRetentionTagUpdateOrchestrator';
import './orchestrators/conversationsRetentionTagUpdateOrchestrator';

import './mutators/itemRetentionTagMutators';

// Create lazily loadable RetentionPolicies chunk.
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "RetentionPolicies" */ './lazyIndex')
);

export const lazyOnArchiveTagForFolderChanged = new LazyImport(
    lazyModule,
    m => m.onArchiveTagForFolderChanged
);

export const lazyOnDeleteTagForFolderChanged = new LazyImport(
    lazyModule,
    m => m.onDeleteTagForFolderChanged
);
